import classNames from "classnames";
import { FunctionComponent, useEffect } from "react";
import { useSelector } from "react-redux";
import Button from "rivals/components/shared/Button";
import {
  getRemoveAddOnSuccess,
  getSubmitting
} from "rivals/redux/subscriptionAddons/selectors";
import { setData } from "rivals/shared/utils/qa";
import styles from "./AssociatedAddOnCard.module.scss";
import strings from "./strings";
import { OwnProps } from "./types";

export const AssociatedAddOnCard: FunctionComponent<OwnProps> = ({
  addOn,
  editMode,
  showRemoveAddOnModal
}) => {
  const isAddOnSubmitting = useSelector(getSubmitting);
  const removeAddOnSuccess = useSelector(getRemoveAddOnSuccess);
  const dataPhilter = "associated-addon-card";
  const { cancellingOn, removeText, upgradeText } = strings;
  const subdomain = addOn && addOn.siteName.toLowerCase().replace(" ", "");
  const addOnIsBundle = addOn.type === "BUNDLE";
  const addOnUpgradeable = addOn.upgradeable !== false;

  useEffect(() => {
    if (removeAddOnSuccess) {
      showRemoveAddOnModal(null);
    }
  }, [removeAddOnSuccess]);

  const removeButton: JSX.Element = (
    <Button
      buttonText={removeText}
      className={styles.actionButton}
      disabled={isAddOnSubmitting}
      inverted
      onClick={(): void => showRemoveAddOnModal(addOn)}
      size="small"
      {...setData(dataPhilter, "remove-add-on")}
    />
  );

  const upgradeButton: JSX.Element = (
    <Button
      buttonText={upgradeText}
      className={classNames([styles.actionButton, styles.upgradeButton])}
      disabled={isAddOnSubmitting}
      inverted
      size="small"
      url={`https://${subdomain}.${process.env.NEXT_PUBLIC_DOMAIN}/subscriptions/new`}
      {...setData(dataPhilter, "upgrade-add-on")}
    />
  );

  return (
    <>
      <div
        className={
          styles[
            `addOnDetails${editMode && !addOn.cancelledAt ? "" : "Editing"}`
          ]
        }
      >
        <div className={styles.title} {...setData(dataPhilter, "add-on-name")}>
          {addOn.title}
          {addOnIsBundle &&
            addOn.spyBundleData &&
            addOn.spyBundleData.bundledSites &&
            !!addOn.spyBundleData.bundledSites.length && (
              <div className={styles.bundleDetails}>
                {addOn.spyBundleData.bundledSites
                  .map(o => o.friendlyName)
                  .join(" . ")}
              </div>
            )}
        </div>
        <div {...setData(dataPhilter, "add-on-price")}>
          {addOn.formattedPriceString}
        </div>
        {addOn.cancelledAt && (
          <div className={styles.cancelledText}>
            {cancellingOn(addOn.cancelledAt)}
          </div>
        )}
      </div>
      <div className={styles.actionsButtonsWrapper}>
        {addOnUpgradeable && upgradeButton}
        {!addOn.cancelledAt && editMode && removeButton}
      </div>
    </>
  );
};
